export default __webpack_public_path__ + "static/home_page_visualization-046d7328ef67918a1b9ab2e7d40cbf9e.mp4";